module.exports = __webpack_public_path__ + "static/hero_cloud_6s-e1d4fc01966df2f67cffad187a9f70bf.mp4";